<template>
    <PrismicRichText
        v-if="slice.primary.content.length"
        class="NewsPostTextBlock"
        :field="slice.primary.content"
    />
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.NewsPostTextBlockSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.NewsPostTextBlock {
    color: var(--black);

    h2,
    h3,
    h4,
    h5 {
        margin-bottom: 2rem;
    }

    p {
        @include body-md;

        margin-bottom: 1.5rem;
    }

    p + h2,
    p + h3,
    p + h4,
    p + h5 {
        margin-top: 3rem;
    }

    a {
        color: var(--black);
    }
}
</style>
